import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import type { PaymentResultType } from "./useAdyenResult";

export type PaymentResultState = {
  paymentResult: PaymentResultType | undefined;
  setPaymentResult: (order: PaymentResultType) => void;
};

const usePaymentStore = create(
  persist<PaymentResultState>(
    (set) => ({
      paymentResult: undefined,
      setPaymentResult: (paymentResult) =>
        set((state) => ({ ...state, paymentResult })),
    }),
    {
      name: "payment-result",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default usePaymentStore;
